const localStorageKey = "dp-messenger-standalone-app";
import { useRouterState } from "@tanstack/react-router";

/**
 * This is only for ease of development, for when opening messenger app directly in the browser, i.e. there is no host page or host app
 * You can enable by adding `?standalone=1` to the url or adding a `.env.local` file with `NEXT_PUBLIC_IS_STANDALONE_APP=1` or adding a localStorage item with key `dp-messenger-standalone-app` and value `1`
 * Disable by adding `?standalone=0` to the url or adding a `.env.local` file with `NEXT_PUBLIC_IS_STANDALONE_APP=0` or deleting the localStorage item with key `dp-messenger-standalone-app`
 */
export default function useIsStandaloneApp() {
  const searchStr = useRouterState({
    select: (state) => state.location.searchStr,
  });
  const searchParams = new URLSearchParams(searchStr);

  const isStandaloneApp = searchParams.get("standalone");

  if (typeof window === "undefined") return false;

  // Query param takes precedence over env var
  if (isStandaloneApp) {
    if (isStandaloneApp === "1") {
      try {
        localStorage.setItem(localStorageKey, isStandaloneApp);
      } catch {
        // Do nothing
      }
      return true;
    }
    if (isStandaloneApp === "0") {
      try {
        localStorage.removeItem(localStorageKey);
      } catch {
        // Do nothing
      }
      return false;
    }
  }

  const envIsStandaloneApp = import.meta.env.VITE_IS_STANDALONE_APP;
  if (envIsStandaloneApp) {
    if (envIsStandaloneApp === "1") {
      try {
        localStorage.setItem(localStorageKey, envIsStandaloneApp);
      } catch {
        // Do nothing
      }
      return true;
    }
    if (envIsStandaloneApp === "0") {
      try {
        localStorage.removeItem(localStorageKey);
      } catch {
        // Do nothing
      }
      return false;
    }
  }

  try {
    return localStorage.getItem(localStorageKey) === "1";
  } catch {
    return false;
  }
}
